function isGroupHeader(option) {
  return option?.groupheader;
}
export {
  isGroupHeader
};
//# sourceMappingURL=omni-dropdown.types.js.map
